import { createDocument, getAllData } from 'apis/customApiHandler';
import Spinner from 'components/Spinner';
import axios from 'apis/axios';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { BiCloudDownload } from 'react-icons/bi';
import { useQuery } from 'react-query';
import ReactSelect from 'react-select';
import { TD, TH } from 'styled/table';
import getFormattedDate from 'utils/helpers';
import exportExcel from 'utils/exportExcel';
import Modal from 'components/Modal';
import { Button, Input, Select } from 'styled';

const contractTypeOptions = [
  { value: "", label: 'All' },
  { value: 'CPKM', label: 'CPKM' },
  { value: 'NON CPKM', label: 'NON CPKM' },
];

const MechanicalIssueReport = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [downloading, setDownloading] = useState(false);
  const [contractType, setContractType] = useState("");

  useEffect(() => {
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    setDateFrom(oneYearAgo.toISOString().split('T')[0]); // Default to one year ago

    const today = new Date();
    setDateTo(today.toISOString().split('T')[0]); // Default to today
  }, []);

  const getFormattedDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  };

  const getData = async () => {
    setIsLoading(true);
    try {
      const dt = await createDocument('/report/mechanical-issue-report', {
        ...(selectedFleets?.includes('all')
          ? {
              fleets: getFleetOptions()
                .filter(
                  (item) => item.value !== 'all' && item.value !== 'clear'
                )
                .map((item) => item.value)
                .join(','),
            }
          : selectedFleets.length && {
              fleets: selectedFleets.map((fleet) => fleet).join(','),
            }),

        ...(contractType &&
          contractType !== 'All' && {
            contractType: contractType,
          }),
        from: dateFrom,
        to: dateTo,
      });
      
      setData(dt);
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  const getDownloadData = async () => {
    setDownloading(true);
    try {
      const dt = await createDocument('/report/mechanical-issue-report', {
        ...(selectedFleets?.includes('all')
          ? {
              fleets: getFleetOptions()
                .filter(
                  (item) => item.value !== 'all' && item.value !== 'clear'
                )
                .map((item) => item.value)
                .join(','),
            }
          : selectedFleets.length && {
              fleets: selectedFleets.map((fleet) => fleet).join(','),
            }),
        ...(contractType &&
          contractType !== 'All' && {
            contractType: contractType,
          }),
        from: dateFrom,
        to: dateTo,
      });
      if (dt) {
        let exportData = dt?.data?.map((x, idx) => ({
          SNo: idx + 1,
          'Fleet Name': `${x?.fleetName} (${x?.fleetCity})`,
          'Enrolled Vehicles': x?.enrolledVehicles,
          OK: x?.ok || 0,
          'Not OK': x?.notOk || 0,
          'Not OK %': x?.percentNotOk.toFixed(2) || 0,
          'Over 30 days %': x?.percentOver30Days.toFixed(2) || 0,
        }));

        exportData.push({
          'Enrolled Vehicles': dt.totalRow?.totalVehicles || 0,
          OK: dt.totalRow?.totalOk || 0,
          'Not OK': dt?.totalRow.totalNotOk || 0,
          'Not OK %': dt?.totalRow?.totalPercentNotOk || 0,
          'Over 30 days %': dt?.totalRow?.totalPercentOver30Days || 0,
        });

        exportExcel(exportData, 'Mechanical issue report', true);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setDownloading(false);
    }
  };

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData('/customer-fleet', {
      limit: 3000,
    })
  );

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: 'All',
          value: 'all',
        },
        {
          label: 'Clear',
          value: 'clear',
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  return (
    <div>
      <div className='w-full px-8 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 justify-center items-center gap-4'>
        <label className='w-full py-3'>
          Select Fleets
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: 'transparent',
                minWidth: '100%',
                '&:hover': {
                  borderColor: 'rgb(34 197 94)',
                },
              }),
            }}
            className='shadow-md rounded-md py-1 mb-2'
            options={getFleetOptions()}
            value={
              selectedFleets &&
              selectedFleets?.map((fleet) => {
                return {
                  value: fleet,
                  label: getFleetOptions()?.find(
                    (item) => item?.value === fleet
                  )?.label,
                };
              })
            }
            onChange={(value) => {
              let allValues = value?.map((item) => item.value);
              if (allValues?.includes('clear')) {
                // console.log(allValues)
                setSelectedFleets([]);

                return;
              }
              if (
                !selectedFleets?.includes('all') &&
                allValues.includes('all')
              ) {
                setSelectedFleets(['all']);
                return;
              }
              // console.log('CLERAININEIENGs')

              if (selectedFleets.includes('all')) {
                // console.log('first');
                // console.log(getFleetOptions())
                value = value.filter((item) => item.value !== 'all');
              }

              // console.log({allHubs, selectedHubs})

              setSelectedFleets(value.map((fleet) => fleet.value));
            }}
            name='fleets'
            isMulti={true}
            // isMulti={selectedFleets?.includes('all') ? false : true}
            // isDisabled={selectedFleets?.includes('all') ? true : false}
          />
        </label>

        <label className='w-full py-3'>
          Contract Type
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: 'transparent',
                minWidth: '100%',
                '&:hover': {
                  borderColor: 'rgb(34 197 94)',
                },
              }),
            }}
            name='contractType'
            className='shadow-md rounded-md py-1 mb-2'
            value={contractTypeOptions.find(
              (option) => option.value === contractType
            )} // Find the option object based on the value
            onChange={(option) => {
              setContractType(option.value); // Store only the value
            }}
            options={contractTypeOptions}
          />
        </label>
        <label className='py-3'>
          From
          <Input
            type='date'
            max={getFormattedDate()}
            name='dateFrom'
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
          />
        </label>
        <label className='py-3'>
          To
          <Input
            type='date'
            min={getFormattedDate(dateFrom)}
            name='dateTo'
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
          />
        </label>
        <div className= "flex flex-row gap-x-3">
        <Button
          type='button'
          className='mt-5'
          disabled={!selectedFleets.length || !dateFrom || !dateTo}
          bgPrimary
          onClick={() => getData()}
        >
          Search
        </Button>
        {downloading
          ? <div className= "h-10 flex items-center align-center text-center justify-center">Downloading...</div>
          : selectedFleets.length !== 0 && (
              <BiCloudDownload
                className='mt-5 h-10 w-10 text-green-500 hover:scale-105 cursor-pointer text-center'
                onClick={() => {
                  getDownloadData();
                }}
              />
            )}
          </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className='flex flex-col m-2 lg:m-10'>
          <div className='-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8'>
            <div className='py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8'>
              <div className='shadow overflow-hidden border-b border-gray-200 sm:rounded-lg'>
                <table className='min-w-full divide-y divide-gray-200'>
                  <thead className='bg-gray-50'>
                    <tr>
                      <TH scope='col'>S.N.</TH>
                      <TH scope='col'>Fleet </TH>
                      <TH scope='col' >Fleet Code</TH>
                      <TH scope='col'>Enrolled Vehicles</TH>
                      <TH scope='col'>OK</TH>
                      <TH scope='col'>Not OK </TH>
                      <TH scope='col'>Not OK %</TH>
                      <TH scope='col'>Over 30 days % </TH>
                    </tr>
                  </thead>
                  <tbody className='bg-white divide-y divide-gray-200'>
                    {data &&
                      data?.data?.map((entry, idx) => (
                        <ViewList
                          contractType ={contractType}
                          dateFrom={dateFrom}
                          dateTo={dateTo}
                          fleetName={entry.fleetName}
                          fleetId={entry.fleetId}
                          data={entry}
                          idx={idx}
                        />
                      ))}
                  </tbody>
                  <tfoot>
                    {data?.totalRow?.totalVehicles ? (
                      <tr className='text-gray-600 font-semibold bg-green-100'>
                        <TD></TD>
                        <TD colSpan={2} className='text-left'>
                          TOTAL
                        </TD>

                        <TD className=''>{data?.totalRow?.totalVehicles}</TD>
                        <TD className=''>{data?.totalRow?.totalOk}</TD>
                        <TD className=''>{data?.totalRow?.totalNotOk}</TD>

                        <TD className=''>
                          {data?.totalRow?.totalPercentNotOk}
                        </TD>
                        <TD className=''>
                          {data?.totalRow?.totalPercentOver30Days}
                        </TD>
                      </tr>
                    ) : (
                      <></>
                    )}
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MechanicalIssueReport;

const ViewList = ({ data, fleetName, fleetId, idx, dateFrom, dateTo, contractType }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false)
  const [modalData, setModalData] = useState([]);
  const [title, setTitle] = useState('');

  const handleModalInfo = async(title)=>{
    setShowModal(true)
    try {
      setLoading(true)
      const payload = {
        fleets: fleetId,
        from: dateFrom,
        to: dateTo,
        contractType,
        mechanicalCondition: title === "Vehicle-Data" ? null : title,
      }
      const dt = await createDocument('/report/mechanical-issue-report-modalinfo', payload)
      if (dt.data?.length) modalHandler(dt?.data, title);
    } catch (err) {

    }finally{
      setLoading(false)
    }
  }

  const modalHandler = useCallback((data, title) => {
    console.log('data', data);
    if (data) {
      setModalData(data);
      setTitle(() => title);
    } else {
      setModalData([]);
    }
  }, []);

  const downloadDiv = (fleetName, data, title) => {
    return (
      data && (
        <div className='flex gap-2'>
          <span
            className='hover:text-green-500 cursor-pointer'
            onClick={() => handleModalInfo(title)}
          >
            {data}
          </span>
        </div>
      )
    );
  };

  return (
    <Fragment>
      {showModal && (
        <Modal
          handleClick={() => setShowModal(false)}
          title={title}
          className='max-w-2xl'
        >
          {loading ? <Spinner/> : 
          <div><h1 className='w-full flex justify-end text-end px-2 my-1'>
            <Button
              onClick={() => {
                let sno = 1;

                const exportData = modalData.flatMap((item) => {
                  return item.mechanicalIssueHistory?.length
                    ? item.mechanicalIssueHistory.map((issue) => {
                      console.log(issue)
                        return {
                          'S.no': sno++,
                          'Fleet Name': `${fleetName} (${data?.fleetCity || "-"})`,
                          'Vehicle Number': item?.vehicleNumber || '',
                          // ...(title === 'Not Ok' ? {
                          Issue: issue?.issue || '',
                          // : null),
                          // ...(title === 'Not Ok' ? {
                          'Reported Hub': issue?.reportedHub || '',
                          //  ' }: null),
                          // ...(title === 'Not Ok' ? {
                          'Reported By': issue?.reportedBy || '',
                          // } : null),
                          //  ...(title === 'Not Ok' ? {
                          'Reported Date': issue?.reportedDate|| '',
                          // : null),
                          // ...(title === 'Not Ok' ? {
                          'Due Days': issue?.dueDays,
                          //  ' }: null),
                          'Last Inspection Date': item?.lastInspDate|| '',
                          'Last Inspection By': item?.inspectedBy || '',
                          'Last Inspection Hub': item?.inspectedHub || '',
                        };
                      })
                    : [
                        {
                          'S.no': sno++,
                          'Fleet Name': `${fleetName} (${data?.fleetCity || "-"})`,
                          'Vehicle Number': item?.vehicleNumber || '',
                          // ...(title === 'Not Ok' ? {
                          Issue: item?.issue || '',
                          // : null),
                          // ...(title === 'Not Ok' ? {
                          'Reported Hub': item?.reportedHub || '',
                          //  ' }: null),
                          // ...(title === 'Not Ok' ? {
                          'Reported By': item?.reportedBy || '',
                          // } : null),
                          //  ...(title === 'Not Ok' ? {
                          'Reported Date': item?.reportedDate || '',
                          // : null),
                          // ...(title === 'Not Ok' ? {
                          'Due Days': item?.dueDays,
                          'Last Inspection Date': item?.lastInspDate ? item.lastInspDate : '',
                          'Last Inspection By': item?.inspectedBy || '', // Last Inspection By
                          'Last Inspection Hub': item?.inspectedHub || '',
                        },
                      ];
                });

                // Call the exportExcel function with the prepared data
                exportExcel(exportData, `${title.split(' ').join('_')}_Data`);
              }}
              className='text-blue-500 hover:scale-105 cursor-pointer text-right'
            >
              Download
            </Button>
          </h1>
          <table className='min-w-full divide-y divide-gray-200'>
            <thead className='bg-gray-50'>
              <tr>
                <TH className='whitespace-nowrap' scope='col'>
                  S.N.
                </TH>
                <TH className='whitespace-nowrap' scope='col'>
                  Fleet Name
                </TH>
                <TH className='whitespace-nowrap' scope='col'>
                  Vehicle Number
                </TH>
                {/* {title === 'Not Ok' ? (
                  <> */}
                <TH className='whitespace-nowrap' scope='col'>
                  Issue
                </TH>
                <TH className='whitespace-nowrap' scope='col'>
                  Reported Hub
                </TH>
                <TH className='whitespace-nowrap' scope='col'>
                  Reported By
                </TH>
                <TH className='whitespace-nowrap' scope='col'>
                  Reported Date
                </TH>
                <TH className='whitespace-nowrap' scope='col'>
                  Due Days
                </TH>
                {/* </>
                ) : null} */}
                <TH className='whitespace-nowrap' scope='col'>
                  Last Inspection Date
                </TH>
                <TH className='whitespace-nowrap' scope='col'>
                  Last Inspection By
                </TH>
                <TH className='whitespace-nowrap' scope='col'>
                  Last Inspection Hub
                </TH>
              </tr>
            </thead>

            <tbody className='bg-white divide-y divide-gray-200'>
              {modalData &&
                modalData.length > 0 &&
                modalData
                  .flatMap((item) => {
                    let first = true;
                    return item.mechanicalIssueHistory?.length
                      ? item.mechanicalIssueHistory.map((issue) => {
                          let obj = {
                            first,
                            ...issue,
                            ...item,
                          };
                          first = false; // Set first to false after the first entry
                          return obj;
                        })
                      : [
                          {
                            ...item,
                            first,
                          },
                        ];
                  })
                  .map((e, index) => (
                    <tr
                      key={index}
                      className={`${e.first ? 'bg-gray-100' : ''}`}
                    >
                      <TD>{index + 1}</TD> {/* Global serial number */}
                      <TD>{`${fleetName} (${data?.fleetCity || "-"})`}</TD>
                      <TD>{e?.vehicleNumber}</TD>
                      {/* {title === 'Not Ok' && (
            <> */}
                      <TD>{e?.issue}</TD>
                      <TD>{e?.reportedHub}</TD>
                      <TD>{e?.reportedBy}</TD>
                      <TD>{e?.reportedDate}</TD>
                      <TD>{e?.dueDays}</TD>
                      {/* </>
          )} */}
                      <TD>{e?.lastInspDate}</TD>
                      <TD>{e?.inspectedBy}</TD>
                      <TD>{e?.inspectedHub}</TD>
                    </tr>
                  ))}
            </tbody>
          </table>
          </div>}
        </Modal>
      )}
      <tr className={`${idx % 2 !== 0 && 'bg-gray-100'}`}>
        <TD>{idx + 1}</TD>
        <TD>{`${fleetName} (${data?.fleetCity || "-"})`}</TD>
        <TD>{data?.fleetCode}</TD>
        <TD
          className='hover:text-green-500 cursor-pointer'
        >
          {downloadDiv(fleetName,data?.enrolledVehicles,"Vehicle-Data")}
        </TD>
        <TD>{data?.ok ? downloadDiv(fleetName, data?.ok, 'Ok') : 0}</TD>
        <TD>
          {data?.notOk ? downloadDiv(fleetName, data?.notOk, 'Not Ok') : 0}
        </TD>
        <TD>{data?.percentNotOk.toFixed(2) || 0}</TD>
        <TD>{data?.percentOver30Days.toFixed(2) || 0}</TD>
      </tr>
    </Fragment>
  );
};
